import React from 'react';
import { Avatar, Button, Tooltip } from '@mui/material';
import { LogoutOutlined } from '@ant-design/icons';
import { logoutApi, BASE_URL } from 'Service/ApiService';
import { clearAuthClientStorage } from 'utils/authSession';
import { showAlert } from 'utils/ErrorMessage';
import { getDeviceInfo } from 'utils/deviceInfo';

// import { useIdle } from 'react-use';
import Swal from 'sweetalert2';

const HeaderContent = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  //const [profileData, setProfileData] = React.useState('');
  const retrieveDataFromLocalStorage = () => {
    //setProfileData(tprofileData ? JSON.parse(tprofileData) : null);
  };

  // const isIdle = useIdle(10000); // 10 seconds (adjust as needed)
  // const isIdle = useIdle(300000); // 5 minutes in milliseconds
  // if (isIdle) {
  //   localStorage.clear();
  //   navigate('/login');
  // }

  const handleLogoutConfirmation = () => {
    // Display a confirmation dialog
    Swal.fire({
      title: 'Logout',
      text: 'Do you want to Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok'
    }).then((result) => {
      // If user confirms logout, call the logout function
      if (result.isConfirmed) {
        handleLogout();
      }
    });
  };

  const handleLogout = async () => {
    try {
      const deviceInfo = getDeviceInfo();
      // console.log('Device Info on Logout:', deviceInfo);

      const response = await logoutApi(user?.userCode, deviceInfo.platform_type);

      if (response.status !== true) {
        showAlert('Error', response.msg, 'error');
        return;
      }
      else {
        clearAuthClientStorage();
        window.location.replace('/login');
      }
    } catch (error) {
      // setLoading(false);
    }
  };

  React.useEffect(() => {
    retrieveDataFromLocalStorage();
  }, []);

  // React.useEffect(() => {
  //   const deviceInfo = getDeviceInfo();
  //   const source = deviceInfo?.platform_type || 'web';

    // const sendLogoutBeacon = () => {
    //   try {
    //     const tuser = JSON.parse(localStorage.getItem('user'));
    //     const userCode = tuser?.userCode;
    //     if (!userCode) return;

    //     const body = `userCode=${encodeURIComponent(userCode)}&deviceId=${null}&source=${encodeURIComponent(source)}`;
    //     const url = `${BASE_URL}logout.php`;
    //     const blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });

    //     if (navigator.sendBeacon) {
    //       navigator.sendBeacon(url, blob);
    //     } else {
    //       // fallback to fetch with keepalive when sendBeacon is not available
    //       fetch(url, {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //         body,
    //         keepalive: true
    //       }).catch(() => {});
    //     }
    //   } catch (e) {
    //     // swallow errors during unload
    //   }
    // };

    // const handleBeforeUnload = () => sendLogoutBeacon();
    // const handlePageHide = () => sendLogoutBeacon();
    // const handleVisibilityChange = () => {
    //   if (document.visibilityState === 'hidden') sendLogoutBeacon();
    // };

    // window.addEventListener('beforeunload', handleBeforeUnload);
    // window.addEventListener('pagehide', handlePageHide);
    // document.addEventListener('visibilitychange', handleVisibilityChange);

    // return () => {
    //   window.removeEventListener('beforeunload', handleBeforeUnload);
    //   window.removeEventListener('pagehide', handlePageHide);
    //   document.removeEventListener('visibilitychange', handleVisibilityChange);
    // };
  // }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        color="inherit"
        startIcon={<LogoutOutlined />}
        onClick={handleLogoutConfirmation}
        sx={{
          display: 'flex',
          justifyContent: 'end',
          color: 'white',
          textTransform: 'none',
          '&:hover': { background: 'transparent' },
          fontSize: 'small'
        }}
        size="small"
      >
        Logout
      </Button>
      <Tooltip title={user == null ? 'Admin' : user.displayName}>
        <Avatar alt={user == null ? 'Admin' : user.displayName} sx={{ ml: 2, width: 30, height: 30 }} />
      </Tooltip>
    </div>
  );
};

export default HeaderContent;
